module.exports = __webpack_public_path__ + "static/media/ProximaNova-BoldIt.54fe7d55.eot";